"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IPlatformPropsSyncManager.js.map